<template lang="pug">
.loader(v-if="loading")
  b-spinner(label="Cargando..." variant="danger")
div(v-else-if="!ovData")
  .container
    b-alert(show variant="danger") No se encontró la oportunidad de venta o hubo un error al cargar.
div(v-else class="revisar-cotizacion-page")
  .container.mb-3
    b-row
      b-col.title-header.d-flex.align-items-center(cols="12")
        div.back-arrow-container.mr-3.cursor-pointer(@click="$router.go(-1)")
          b-icon-arrow-left.h4.mb-0
        h1.title.mb-0 Revisar Cotización OV {{ ovData.id }}
    b-row.mt-2
      b-col(cols="12")
        .custom-breadcrumb
          router-link(to="/") Inicio
          span.mx-2 /
          router-link(to="/oportunidad-venta") Oportunidad de Venta
          span.mx-2 /
          span.text-muted Revisar Cotización OV {{ ovData.id }}
  
  b-container
    b-row
      //- Main Column
      b-col(cols="12" xl="8")
        b-card(rounded-4 class="mb-3 border-0 shadow-sm main-card")
          //- Banner de estado
          b-alert(
            :show="ovData.estado !== 'Cotización por Revisar'" 
            variant="warning" 
            class="mb-4"
          ) 
            | Esta cotización se encuentra en estado #[strong {{ ovData.estado }}]. Solo se puede revisar y aprobar si está en "Cotización por Revisar".
          
          h5.ov-number OV {{ ovData.id }}
          
          //- Datos Cliente
          .section-block
            .section-header
              b-icon-person-badge-fill.mr-2.section-icon
              h3.section-title Datos del Cliente
            .data-grid-5
              .data-item
                .data-label.text-blue R.U.T.
                .data-info {{ ovData.datos_cliente.rut || '-' }}
              .data-item
                .data-label Nombre
                .data-info {{ ovData.datos_cliente.nombre || '-' }}
              .data-item
                .data-label Apellido
                .data-info {{ ovData.datos_cliente.apellido || '-' }}
              .data-item
                .data-label Teléfono
                .data-info {{ ovData.datos_cliente.telefono || '-' }}
              .data-item
                .data-label Correo
                .data-info {{ ovData.datos_cliente.correo_electronico || '-' }}
            .data-grid-5.mt-3
              .data-item
                .data-label Comuna
                .data-info {{ ovData.datos_cliente.comuna || '-' }}
              .data-item
                .data-label Región
                .data-info {{ ovData.datos_cliente.region || '-' }}
              .data-item.col-span-3
                .data-label Dirección
                .data-info {{ ovData.datos_cliente.direccion || '-' }}
          
          //- Datos Equipo
          .section-block
            .section-header
              b-icon-laptop.mr-2.section-icon
              h3.section-title Datos del Equipo
            .data-grid-5
              .data-item
                .data-label.text-blue N° de Serie
                .data-info {{ (ovData.datos_equipo && ovData.datos_equipo.numero_serie) ? ovData.datos_equipo.numero_serie : '-' }}
              .data-item
                .data-label Modelo
                .data-info {{ (ovData.datos_equipo && ovData.datos_equipo.modelo) ? ovData.datos_equipo.modelo : '-' }}
              .data-item
                .data-label Marca
                .data-info {{ (ovData.datos_equipo && ovData.datos_equipo.marca) ? ovData.datos_equipo.marca : '-' }}
          
          //- Ítems Cotizados
          .section-block
            .section-header
              b-icon-tools.mr-2.section-icon
              h3.section-title Ítems Cotizados
            
            .custom-table-container
              table.custom-table
                thead
                  tr
                    th.text-left Producto
                    th.text-center Cantidad
                    th.text-center Precio Unitario
                    th.text-right Subtotal
                tbody
                  tr(v-if="!ovData.items || ovData.items.length === 0")
                    td(colspan="4").text-center.py-3 No hay ítems en esta cotización
                  tr(v-for="(item, index) in ovData.items" :key="index")
                    td.text-left
                      .item-code(v-if="item.part_number") COD: {{ item.part_number }}
                      .item-desc {{ item.descripcion }}
                    td.text-center.font-weight-bold {{ item.cantidad }}
                    td.text-center.font-weight-bold {{ item.precio_unitario | formatClp }}
                    td.text-right.font-weight-bold {{ item.subtotal_sin_descuento | formatClp }}

          //- Falla
          .section-block(v-if="ovData.ot")
            .section-header
              b-icon-file-earmark-text.mr-2.section-icon
              h3.section-title Reporte de la Falla
            
            .data-item.mb-3
              .data-label Comentario
              .data-info-text {{ ovData.ot.descripcion || '-' }}

          //- Diagnóstico
          .section-block(v-if="ovData.ot")
            .section-header
              b-icon-clipboard-plus.mr-2.section-icon
              h3.section-title Diagnóstico
            
            .data-grid-4.mb-3
              .data-item
                .data-label Status
                .data-info {{ ovData.ot.diagnostico_status || '-' }}
              .data-item
                .data-label Fecha
                .data-info {{ ovData.ot.diagnostico_fecha || '-' }}
              .data-item.col-span-2
                .data-label ¿Se pudo replicar la falla?
                .data-info {{ ovData.ot.se_pudo_replicar || '-' }}
            
            .data-item
              .data-label Informe
              .data-info-text {{ ovData.ot.diagnostico || '-' }}

      //- Sidebar Column
      b-col(cols="12" xl="4")
        b-card(rounded-4 class="border-0 shadow-sm side-card mb-4")
          .section-header.mb-3
            b-icon-file-earmark-pdf-fill.mr-2.section-icon
            h3.section-title Sección PDF
            
          .pdf-gray-box
            .pdf-file-info.d-flex.align-items-center.mb-3
              .pdf-icon-bg.mr-3
                span.font-weight-bold.text-white PDF
              div
                .pdf-filename {{ ovData.pdf_nombre || 'Cotizacion.pdf' }}
                .pdf-date Generado hoy, {{ ovData.pdf_generado_en ? ovData.pdf_generado_en.split(' ')[1] : '' }} hrs

            b-button.w-100.mb-2.btn-pdf-view(variant="outline-primary" @click="viewPdf" :disabled="!ovData.pdf_url")
              b-icon-eye.mr-2
              | Ver PDF
            b-button.w-100.btn-pdf-regen(variant="outline-secondary" @click="regenerarPdf" :disabled="isRegenerating || isNotPorRevisar")
              b-spinner(small class="mr-2" v-if="isRegenerating")
              b-icon-arrow-clockwise.mr-2(v-else)
              | Regenerar PDF

          b-card(rounded-4 class="border-0 shadow-sm side-card mb-4")
            .section-header.mb-3
              b-icon-receipt-cutoff.mr-2.section-icon
              h3.section-title Descuentos Aplicados
              
            .yellow-summary-box
              .d-flex.justify-content-between.mb-2
                span.summary-label Sub Total
                span.summary-value {{ ovData.subtotal | formatClp }}
                
              .d-flex.justify-content-between.mb-3
                span.summary-label Descuento
                span.summary-value -{{ ovData.total_descuentos | formatClp }}
                
              .summary-divider
              
              .d-flex.justify-content-between.mt-3.align-items-center
                span.summary-total-label Total
                span.summary-total-value {{ ovData.total | formatClp }}

          //- Action Buttons
          b-button.w-100.mb-2.btn-approve(
            @click="showApproveModal = true"
            :disabled="isNotPorRevisar"
          ) Enviar COT
            
          b-button.w-100.mb-2.btn-modify(
            @click="showRejectModal = true"
            :disabled="isNotPorRevisar"
          ) Modificar COT
          
          b-button.w-100.btn-close(
            @click="$router.go(-1)"
          ) Cerrar

  //- Modal Aprobar
  b-modal(
    v-model="showApproveModal"
    centered
    header-border-variant="white"
    footer-border-variant="white"
    content-class="custom-modal"
    no-close-on-backdrop
  )
    template(#modal-header="{ close }")
      h5.modal-custom-title ¿Aprobar y enviar cotización?
      b-icon-x.cursor-pointer.h4.mb-0.text-muted(@click="close" v-if="!isActionLoading")
      
    .text-center.modal-body-content
      .modal-icon-wrapper.success-bg.mb-4
        b-icon-check.text-white.modal-large-icon
      p.modal-desc.mb-1 Al aprobar, se enviará automáticamente el PDF con la cotización al correo del cliente “{{ ovData.datos_cliente.correo_electronico }}”
      p.modal-desc.mb-1 La OV avanzará a #[strong Cotización Enviada].
      p.modal-desc.mb-0 Esta acción no se puede deshacer.
      b-spinner(v-if="isActionLoading" variant="success" class="mt-3")

    template(#modal-footer="{ close }")
      .w-100.d-flex.justify-content-between
        b-button.btn-modal-cancel(@click="close" :disabled="isActionLoading") Cancelar
        b-button.btn-modal-confirm(@click="approveAndSend" :disabled="isActionLoading") Aprobar y Enviar

  //- Modal Rechazar/Modificar
  b-modal(
    v-model="showRejectModal"
    centered
    header-border-variant="white"
    footer-border-variant="white"
    content-class="custom-modal"
    no-close-on-backdrop
  )
    template(#modal-header="{ close }")
      h5.modal-custom-title ¿Estás seguro que deseas modificar la cotización?
      b-icon-x.cursor-pointer.h4.mb-0.text-muted(@click="close" v-if="!isActionLoading")
      
    .text-center.modal-body-content
      .modal-icon-wrapper.danger-text.mb-4
        b-icon-exclamation-triangle-fill.modal-xl-icon
      p.modal-desc.mb-1 La Oportunidad de Venta regresará al estado #[strong Completado].
      p.modal-desc.mb-0 El PDF actual será descartado para generar una nueva cotización.
      b-spinner(v-if="isActionLoading" variant="danger" class="mt-3")

    template(#modal-footer="{ close }")
      .w-100.d-flex.justify-content-between
        b-button.btn-modal-cancel(@click="close" :disabled="isActionLoading") Cancelar
        b-button.btn-modal-confirm(@click="rejectForModification" :disabled="isActionLoading") Modificar Cotización

</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'RevisarCotizacionView',
  data() {
    return {
      loading: true,
      ovData: null,
      isRegenerating: false,
      isActionLoading: false,
      showApproveModal: false,
      showRejectModal: false,
    }
  },
  computed: {
    isNotPorRevisar() {
      return this.ovData?.estado !== 'Cotización por Revisar'
    },
  },
  filters: {
    formatClp(value) {
      if (!value) return '$0'
      return `$${value.toLocaleString('es-CL')}`
    },
  },
  methods: {
    ...mapActions('OVStore', [
      'getDetalleRevisionCotizacion',
      'regenerarPDFCotizacion',
      'aprobarCotizacion',
      'rechazarRevisionCotizacion',
    ]),
    async fetchRevisionData() {
      this.loading = true
      try {
        const response = await this.getDetalleRevisionCotizacion(
          this.$route.params.id
        )
        if (response && response.data) {
          this.ovData = response.data
        }
      } catch (error) {
        this.$bvToast.toast('Error al cargar detalle de revisión', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    viewPdf() {
      if (this.ovData && this.ovData.pdf_url) {
        window.open(this.ovData.pdf_url, '_blank')
      }
    },
    async regenerarPdf() {
      this.isRegenerating = true
      try {
        const response = await this.regenerarPDFCotizacion(
          this.$route.params.id
        )
        if (response.status === 200) {
          this.$bvToast.toast('El PDF ha sido regenerado correctamente.', {
            title: 'Éxito',
            variant: 'success',
            solid: true,
          })
          await this.fetchRevisionData()
        }
      } catch (error) {
        this.$bvToast.toast(
          error.response?.data?.error || 'Error al regenerar PDF',
          {
            title: 'Error',
            variant: 'danger',
            solid: true,
          }
        )
      } finally {
        this.isRegenerating = false
      }
    },
    async approveAndSend(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.isActionLoading = true
      try {
        const response = await this.aprobarCotizacion(this.$route.params.id)
        if (response.status === 200) {
          this.$bvToast.toast('La cotización fue aprobada y enviada.', {
            title: 'Cotización Enviada',
            variant: 'success',
            solid: true,
          })
          this.showApproveModal = false
          setTimeout(() => {
            this.$router.push(`/oportunidad-venta/${this.$route.params.id}`)
          }, 1500)
        }
      } catch (error) {
        this.$bvToast.toast(
          error.response?.data?.error || 'Error al aprobar cotización',
          {
            title: 'Error',
            variant: 'danger',
            solid: true,
          }
        )
        this.showApproveModal = false
      } finally {
        this.isActionLoading = false
      }
    },
    async rejectForModification(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.isActionLoading = true
      try {
        const response = await this.rechazarRevisionCotizacion(
          this.$route.params.id
        )
        if (response.status === 200) {
          this.$bvToast.toast('Cotización enviada a modificación.', {
            title: 'Cotización Modificada',
            variant: 'info',
            solid: true,
          })
          this.showRejectModal = false
          setTimeout(() => {
            this.$router.push(`/oportunidad-venta/${this.$route.params.id}`)
          }, 1500)
        }
      } catch (error) {
        this.$bvToast.toast(
          error.response?.data?.error || 'Error al solicitar modificación',
          {
            title: 'Error',
            variant: 'danger',
            solid: true,
          }
        )
        this.showRejectModal = false
      } finally {
        this.isActionLoading = false
      }
    },
  },
  mounted() {
    this.fetchRevisionData()
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.revisar-cotizacion-page {
  background-color: #f5f6fa;
  min-height: 100vh;
  padding-bottom: 2rem;
}

// Header & Breadcrumbs
.back-arrow-container {
  background-color: $samtek-yellow;
  border-radius: 8px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #23201c;
}
.title {
  font-size: 22px;
  font-weight: 700;
  color: #23201c;
}
.custom-breadcrumb {
  font-size: 13px;
  a {
    color: #525252;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
  .text-muted {
    color: #8f8f8f !important;
  }
}

// Cards
.main-card {
  ::v-deep .card-body {
    padding: 32px;
  }
}
.side-card {
  ::v-deep .card-body {
    padding: 24px;
  }
}
.ov-number {
  font-size: 16px;
  font-weight: 700;
  color: #525252;
  margin-bottom: 24px;
}

// Sections
.section-block {
  margin-bottom: 32px;
}
.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.section-icon {
  font-size: 20px;
  color: #23201c;
}
.section-title {
  font-size: 18px;
  font-weight: 700;
  color: #23201c;
  margin: 0;
}

// Data Grids
.data-grid-5 {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
}
.data-grid-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}
.col-span-2 {
  grid-column: span 2;
}
.col-span-3 {
  grid-column: span 3;
}

@media (max-width: 991px) {
  .data-grid-5,
  .data-grid-4 {
    grid-template-columns: repeat(2, 1fr);
  }
  .col-span-2,
  .col-span-3 {
    grid-column: span 1;
  }
}
@media (max-width: 575px) {
  .data-grid-5,
  .data-grid-4 {
    grid-template-columns: 1fr;
  }
}

.data-label {
  font-size: 13px;
  font-weight: 700;
  color: #23201c;
  margin-bottom: 4px;
}
.data-info {
  font-size: 14px;
  color: #525252;
}
.data-info-text {
  font-size: 14px;
  color: #525252;
  line-height: 1.5;
}
.text-blue {
  color: #1d4ed8;
}

// Custom Table
.custom-table-container {
  overflow-x: auto;
}
.custom-table {
  width: 100%;
  border-collapse: collapse;
  th {
    background-color: #e9ecef;
    padding: 12px 16px;
    font-size: 13px;
    font-weight: 700;
    color: #525252;
    border: none;
  }
  td {
    padding: 16px;
    font-size: 14px;
    color: #23201c;
    border-bottom: 1px solid #f0f0f0;
  }
}
.item-code {
  font-size: 11px;
  color: #8f8f8f;
  margin-bottom: 2px;
}
.item-desc {
  font-size: 14px;
  color: #23201c;
}

// Sidebar PDF
.pdf-gray-box {
  background-color: #e9ecef;
  border-radius: 8px;
  padding: 20px;
}
.pdf-icon-bg {
  background-color: #dc3545;
  border-radius: 4px;
  padding: 8px 12px;
}
.pdf-filename {
  font-size: 14px;
  font-weight: 700;
  color: #23201c;
}
.pdf-date {
  font-size: 12px;
  color: #525252;
}
.btn-pdf-view {
  background-color: white;
  color: #1d4ed8;
  border-color: #1d4ed8;
  font-weight: 600;
  border-radius: 8px;
  &:hover {
    background-color: #f8f9fa;
  }
}
.btn-pdf-regen {
  background-color: white;
  color: #525252;
  border-color: #ced4da;
  font-weight: 600;
  border-radius: 8px;
  &:hover {
    background-color: #f8f9fa;
  }
}

// Sidebar Summary
.yellow-summary-box {
  background-color: #fff9e6;
  border-radius: 12px;
  padding: 20px;
}
.summary-label {
  font-size: 14px;
  font-weight: 700;
  color: #525252;
}
.summary-value {
  font-size: 14px;
  color: #525252;
}
.summary-divider {
  height: 1px;
  background-color: #e0d9c1;
  margin: 12px 0;
}
.summary-total-label {
  font-size: 16px;
  font-weight: 700;
  color: #23201c;
}
.summary-total-value {
  font-size: 18px;
  font-weight: 800;
  color: #23201c;
}

// Main Actions
.btn-approve {
  background-color: #38c78c !important;
  color: white !important;
  font-weight: 600;
  border-radius: 8px;
  border: none !important;
  padding: 10px;
  &:hover:not(:disabled) {
    background-color: #2da171 !important;
  }
}
.btn-modify {
  background-color: #ff3c3c !important;
  color: white !important;
  font-weight: 600;
  border-radius: 8px;
  border: none !important;
  padding: 10px;
  &:hover:not(:disabled) {
    background-color: #e53232 !important;
  }
}
.btn-close {
  background-color: #fdcc28 !important;
  color: #23201c !important;
  font-weight: 600;
  border-radius: 8px;
  border: none !important;
  padding: 10px;
  &:hover {
    background-color: #e5b620 !important;
  }
}

// Modals
::v-deep .custom-modal .modal-content {
  border-radius: 12px;
  border: none;
}
::v-deep .custom-modal .modal-header {
  padding: 24px 24px 0 24px;
}
::v-deep .custom-modal .modal-footer {
  padding: 0 24px 24px 24px;
}
.modal-custom-title {
  font-weight: 700;
  font-size: 18px;
  color: #23201c;
  margin: 0;
}
.modal-body-content {
  padding: 10px 20px;
}
.modal-icon-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
}
.success-bg {
  background-color: #20d489;
  border-radius: 50%;
}
.danger-text {
  color: #ff4d4f;
}
.modal-large-icon {
  font-size: 64px;
}
.modal-xl-icon {
  font-size: 80px;
}
.modal-desc {
  color: #525252;
  font-size: 14px;
  line-height: 1.5;
}
.btn-modal-cancel {
  background-color: white !important;
  color: #23201c !important;
  border: 1px solid #fccc3c !important;
  font-weight: 600;
  border-radius: 8px;
  padding: 10px 24px;
}
.btn-modal-confirm {
  background-color: #fccc3c !important;
  color: #23201c !important;
  border: none !important;
  font-weight: 600;
  border-radius: 8px;
  padding: 10px 24px;
  &:hover {
    background-color: #f7be16 !important;
  }
}
</style>
